import React from "react";
import { Search, ClipboardCheck, Sparkles, Truck, ArrowRight } from "lucide-react";

const Process = () => {
  const steps = [
    {
      id: "01",
      title: "Selection",
      desc: "Browse our live inventory. Filter by age, weight, and pedigree.",
      icon: <Search size={20} />,
    },
    {
      id: "02",
      title: "Verification",
      desc: "Detailed health reports and genetic certificates provided.",
      icon: <ClipboardCheck size={20} />,
    },
    {
      id: "03",
      title: "Booking",
      desc: "Transparent booking process with full documentation.",
      icon: <Sparkles size={20} />,
    },
    {
      id: "04",
      title: "Logistics",
      desc: "Professional climate-controlled transport to your facility.",
      icon: <Truck size={20} />,
    },
  ];

  return (
    <section className="py-12 bg-[#FDFCF8] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        
        <div className="text-center mb-10">
          <span className="text-[9px] font-black uppercase tracking-[0.5em] text-[#D4AF37] block mb-2">
            The Workflow
          </span>
          <h2 className="text-3xl font-black text-[#4B3621] tracking-tighter leading-tight">
            Acquisition <span className="text-[#2D5A27]">Process.</span>
          </h2>
          <p className="mt-3 text-xs text-gray-500 font-medium max-w-lg mx-auto leading-relaxed">
            A streamlined, transparent four-step journey from our research farm to your facility.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-10 left-0 w-full h-[1px] bg-gray-200 z-0"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative z-10">
            {steps.map((step, index) => (
              <div key={index} className="group flex flex-col items-center text-center">
                
                <div className="w-20 h-20 bg-white border border-gray-100 rounded-2xl flex items-center justify-center shadow-md mb-4 group-hover:border-[#2D5A27] group-hover:bg-[#2D5A27] transition-all duration-500 relative">
                  <div className="text-[#2D5A27] group-hover:text-white transition-colors duration-500">
                    {step.icon}
                  </div>
                  
                  <div className="absolute -top-2 -right-2 w-7 h-7 bg-[#2D5A27] text-white text-[9px] font-black rounded-lg flex items-center justify-center shadow-md group-hover:bg-[#D4AF37] group-hover:text-[#4B3621] transition-colors">
                    {step.id}
                  </div>
                </div>

                <h3 className="text-sm font-black text-[#4B3621] mb-2 uppercase tracking-tight">
                  {step.title}
                </h3>
                <p className="text-gray-500 text-[11px] font-medium leading-normal max-w-[200px]">
                  {step.desc}
                </p>

                {index !== steps.length - 1 && (
                  <div className="lg:hidden mt-4 text-gray-200">
                    <ArrowRight size={16} className="rotate-90" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;